<template>
  <div>
    <v-card flat v-if="loading">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card-text>
            Cargando...
            <v-progress-linear
              indeterminate
              color="blue"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-layout>
      </v-container>
    </v-card>
    <v-card flat v-if="!loading && notFound">
      <v-alert :value="true" type="error" color="red">
        Edificio no encontrado.
      </v-alert>
    </v-card>
    <v-card flat v-if="!loading && !notFound">
      <v-toolbar flat color="white">
        <v-toolbar-title>Listado de sensores</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar nombre..."
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        select-all
        rows-per-page-text="Filas por página:"
        :rows-per-page-items="rowsPerPageItems"
        :headers="headers"
        :items="sensoresSolos"
        :search="search"
        :loading="loading"
        item-key="key"
        :expand="expand"
        class="elevation-1"
      >
        <template v-slot:no-data>
          <v-alert v-if="!loading" :value="true" type="warning" color="orange">
            No hay datos guardados
          </v-alert>
          <v-alert v-if="loading" :value="true" type="info" color="blue">
            Cargando...
          </v-alert>
        </template>
        <template v-slot:progress>
          <v-progress-linear color="blue" indeterminate></v-progress-linear>
        </template>
        <template v-slot:items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td @click.stop="">
              <v-checkbox
                v-model="props.selected"
                color="primary"
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-center">
              <v-avatar size="40" color="grey lighten-4">
                <img
                    v-show="!noSensorPhoto(props.item)"
                    id="photo"
                    :src="sensorPhoto(props.item)"
                    alt="avatar"
                />
                <v-icon v-if="noSensorPhoto(props.item)" size="30">security</v-icon>
              </v-avatar>
            </td>
            <td>
              <ProfileLink
                :key="props.item.key"
                v-bind:idKey="props.item.key"
                type="sensor"
              ></ProfileLink>
            </td>
            <td class="text-xs-right">
              <ProfileLink
                  :key="props.item.building"
                  v-bind:idKey="props.item.building"
                  type="building"
                  v-if="props.item.building"
              />
            </td>
            <td class="text-xs-right">{{ mostrarFecha(props.item.dateLastActivation) }}</td>
            <td class="text-xs-right">
              {{ mostrarFecha(props.item.dateRegistration) }}
            </td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" type="error" color="red">
            No se ha encontrado el sensor "{{ search }}".
          </v-alert>
        </template>
        <template v-slot:expand="props">
          <v-card>
            <v-card-text v-if="props.item.description === ''">
              Sin descripción.
            </v-card-text>
            <v-card-text v-if="props.item.description !== ''">
              {{ props.item.description }}
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:pageText="props">
          Filas de {{ props.pageStart }} a {{ props.pageStop }} de
          {{ props.itemsLength }} totales
        </template>
      </v-data-table>
    </v-card>
    <p style="margin: 6px 8px;">
      <v-btn
        :loading="loadingAction"
        :disabled="sameData"
        color="primary"
        @click.stop="agregarSensores"
      >
        {{ titulo }}
      </v-btn>
      {{ selected.length }} elementos seleccionados
    </p>
    <v-alert
        :value="exito"
        type="success"
        dismissible
    >
      Sensores cambiados con éxito.
    </v-alert>
  </div>
</template>

<script>
import ProfileLink from "@/components/links/ProfileLink.vue";
import firebase from "firebase";

let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBnuZJIuRvweJ_qX4ZEmQCe2cerF92RCz4",
    authDomain: "tfgr-9ed26.firebaseapp.com",
    databaseURL: "https://tfgr-9ed26.firebaseio.com",
    projectId: "tfgr-9ed26",
    storageBucket: "tfgr-9ed26.appspot.com",
    messagingSenderId: "47742064305"
  });
} else {
  firebaseApp = firebase.app();
}

// Export the database for components to use.
// If you want to get fancy, use mixins or provide / inject to avoid redundant imports.
export const db = firebaseApp.database();

function arraysEqual(a, b) {
  // Compara si dos arrays ordenados son iguales en contenido
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

//Menú para añadir sensores a un edificio o grupo
export default {
  name: "AddSensors",
  props: {
    // ID del objeto
    idKey: {
      default: "",
      type: String
    },
    // Tabla del objeto
    tabla: {
      default: "",
      type: String
    }
  },
  components: {
    ProfileLink
  },
  data() {
    return {
      loading: true,
      loadingAction: false,
      exito: false,
      selected: [],
      search: "",
      expand: false,
      rowsPerPageItems: [10 /*, 20, 30, 40*/],
      headers: [
        { text: "Foto", align: "center", sortable: false },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Edificio", align: "right", value: "building" },
        { text: "Última activación", align: "right", value: "dateLastActivation" },
        { text: "Fecha de registro", align: "right", value: "dateRegistration" }
      ]
    };
  },
  created() {
    this.$bindAsArray(
      "vectorObjecto",
      db
        .ref(this.tabla)
        .orderByChild("key")
        .equalTo(this.idKey)
        .limitToFirst(1),
      snap => {
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
    this.$bindAsArray(
      "vectorSensoresSelec",
      db
        .ref(this.tabla + "Sensors")
        .orderByChild("key")
        .equalTo(this.idKey)
        .limitToFirst(1),
      snap => {
        if (
          this.vectorSensoresSelec.length !== 0 &&
          this.vectorSensoresSelec[0].sensors !== undefined &&
          this.vectorSensoresSelec[0].sensors !== null
        ) {
          for (let i = 0; i < this.vectorSensoresSelec[0].sensors.length; i++) {
            this.selected.push({ key: this.vectorSensoresSelec[0].sensors[i] });
          }
        }
        this.loading = false;
      },
      error => {
        if (
          this.vectorSensoresSelec.length !== 0 &&
          this.vectorSensoresSelec[0].sensors !== undefined &&
          this.vectorSensoresSelec[0].sensors !== null
        ) {
          for (let i = 0; i < this.vectorSensoresSelec[0].sensors.length; i++) {
            this.selected.push({ key: this.vectorSensoresSelec[0].sensors[i] });
          }
        }
        this.loading = false;
      }
    );
    this.$bindAsArray(
      "sensores",
      db
        .ref("sensors")
        .orderByChild("owner")
        .equalTo(this.$store.state.user.uid),
      snap => {
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  },
  methods: {
    emitToParent() {
      // Se lanza cuando se añaden sensores
      this.$emit("sensorsAdded", true);
    },
    // @vuese
    // Agrega los sensores seleccionados
    // @arg Sensores seleccionados
    agregarSensores() {
      this.exito = false;
      this.loadingAction = true;
      let self = this;
      let selecionados = [];
      for (let i = 0; i < this.selected.length; i++) {
        selecionados.push(this.selected[i].key);
      }
      this.$store
        .dispatch("addSensores", {
          anteriores: this.sensoresSolos,
          sensores: selecionados,
          key: this.idKey,
          table: this.tabla + "Sensors"
        })
        .then(function() {
          self.loadingAction = false;
          self.emitToParent();
          self.exito = true;
        })
        .catch(error => {
          self.loadingAction = false;
          self.emitToParent();
          self.exito = true;
        });
    },
    // @vuese
    // Procesa un objeto date y lo muestra formateado
    // @arg Fecha
    mostrarFecha(fecha) {
      if (fecha === null || fecha === undefined) {
        return "";
      }
      let dateStr = JSON.parse('"' + fecha + '"');
      let date = new Date(dateStr);
      return date.toLocaleString("es-ES");
    },
    // @vuese
    // Extrae la foto del un sensor de la lista
    // @arg Item de la lista
    sensorPhoto(item) {
      if (
        item === null ||
        item === undefined ||
        item.photo === null ||
        item.photo === undefined
      ) {
        return "/img/user.svg";
      } else {
        return item.photo;
      }
    },
    // @vuese
    // Indica si un sensor de la lista no tiene foto
    // @arg Item de la lista
    noSensorPhoto(item) {
      if (
        item === null ||
        item === undefined ||
        item.photo === null ||
        item.photo === undefined
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  computed: {
    // @vuese
    // Procesa los sensores a mostrar. En el caso del edificio, mostrar solo los sensores que no tienen edificio o son de ese edificio.
    sensoresSolos() {
      if (this.tabla === "buildings") {
        let retorno = [];
        for (let i = 0; i < this.sensores.length; i++) {
          if (
            this.sensores[i].building === null ||
            this.sensores[i].building === undefined ||
            this.sensores[i].building === this.idKey
          ) {
            retorno.push(this.sensores[i]);
          }
        }
        return retorno;
      } else {
        //En el caso de un grupo mostrar todos
        return this.sensores;
      }
    },
    // @vuese
    // Deshabilita el botón de guardar cambios si no hay cambios
    deshabilitarMod() {
      return !this.marcado || this.sameData;
    },
    // @vuese
    // Comprueba si ha habido cambios
    sameData() {
      if (!this.hasSensores) {
        return this.selected.length === 0;
      }
      let seleccionados = [];
      for (let i = 0; i < this.selected.length; i++) {
        seleccionados.push(this.selected[i].key);
      }
      seleccionados.sort();
      return arraysEqual(seleccionados, this.vectorSensoresSelec[0].sensors);
    },
    // @vuese
    // Indica si el objeto no ha sido encontrado
    notFound() {
      if (
        this.vectorObjecto === null ||
        this.vectorObjecto === undefined ||
        this.vectorObjecto.length === 0 ||
        this.vectorObjecto[0] === null ||
        this.vectorObjecto[0] === undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Indica si el objeto tiene sensores asociados
    hasSensores() {
      if (
        this.loading ||
        this.vectorSensoresSelec === null ||
        this.vectorSensoresSelec === undefined
      ) {
        return false;
      }
      if (
        this.vectorSensoresSelec.length === 0 ||
        this.vectorSensoresSelec[0] === null ||
        this.vectorSensoresSelec[0] === undefined ||
        this.vectorSensoresSelec[0].sensors === null ||
        this.vectorSensoresSelec[0].sensors === undefined ||
        this.vectorSensoresSelec[0].sensors.length === 0
      ) {
        return false;
      } else {
        return true;
      }
    },
    // @vuese
    // Cambia el título del botón de guardar en función de si hay sensores o no.
    titulo() {
      if (this.hasSensores) {
        return "Modificar";
      } else {
        return "Agregar";
      }
    }
  }
};
</script>

<style scoped>
.boton {
  flex-basis: 60%;
}
</style>
